import store from './plugins/vuex';
export default class Gate{

    constructor( ){
        console.log('EN constructor gate')
        var myuser = store.state.user;
       /* if(!myuser ){
            //console.log('entra> '+myuser);
            this.getUserLogin();
        }else{*/

            if(myuser)
            this.usuario = myuser.lxvl;
       // }
        //console.log(this.usuario+" :contruc")
        this.urlApi = '';
    }

    getApiUrl(local=0){
        let url = 'https://api.layer.huully.net.pe/api/';//'http://127.0.0.1:8000/api/';//
        return url;
    }

    setTypeUser(type){
        switch(type){
           case 0: return 'admin'; break;
           case 1: return 'Administración'; break;
           case 11: return 'Seguridad'; break;
           case 2: return 'Supervisor(a) de Caja Administrativa'; break;
           case 21: return 'Auditor de Caja'; break;
           //case 3: return ''; break;
        }

    }

    setUserLogin(loguser){
        /*localStorage.clear();
        this.usuario = loguser.lxvl;
        let parsed = JSON.stringify(loguser);
        this.setTokenUser(loguser.token);
        localStorage.setItem('user', parsed);*/
        //localStorage.setItem('token', loguser.token);
    }

    getUserLogin(){
       //var usery = JSON.parse(localStorage.getItem('user'));
       //console.log(usery+' > getuserlogin');
       //this.setTokenUser(usery.token);
       //store.dispatch('user',usery);
    }

    getTiendaId(){
        return  store.state.user.sucursal;
    }

    setTokenUser(token){
       // window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;//localStorage.getItem('token');
    }

	/**
	 * Removes JWT token from session and local storage
	 */
	removeLogin() {
        //let userData = store.state.user;
        //userData.token ='';
        //localStorage.removeItem('token');
        //localStorage.removeItem('user');
        //sessionStorage.clear();
        store.dispatch('user', null);
        localStorage.clear();
    }

    esLogeado(){
        if( store.state.user/*localStorage.getItem('token')*/) {
            return true;
        }else{
            return false;
        }
    }

    getTipoUsuario(){
        return  store.state.user.lxvl;
    }

    idUser(userlog){
        return userlog.id;
    }

    isAdmin(){
        return this.usuario  === 0;//'super usuario';
    }

    isUserAdm(){
        return this.usuario  === 2;//'Caja Adm supervisora';
    }

    isUser(){
        return this.usuario  === 21;//'Receptora';
    }

    isSecurity(){
        return this.usuario  === 11;//'Seguridad';
    }

    isAuthor(){
        return this.usuario  === 1;//'supervisor';
    }

    isUserAdminOrUser(){
        return(this.usuario  === 2 || this.usuario  === 21);
    }

    isUserAdminOrMer(){
      return(this.usuario  === 0 || this.usuario  === 4);
    }

    isAllAdminOrUsers(){
        return (this.usuario  === 2 || this.usuario  === 0 || this.usuario  === 1);
    }

    isAdminOrAuthor(){
        return(this.usuario  === 0 || this.usuario  === 1);
    }
    isAuthorOrUser(){
        return(this.usuario  === 2 || this.usuario  === 1);
    }
}
